import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../service/auth.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];

  constructor(public authService: AuthService, private translationService: TranslateService, private router: Router) { }

  ngOnInit(): void {
    // By default set to the borwser lang until the user signs in
    this.translationService.use(this.translationService.getBrowserLang());

    this.subscriptions.push(this.authService.businessProfileChanged.subscribe(profile => {
      if (profile) {
        this.router.navigate(['/home']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
